module.exports = __webpack_public_path__ + "img/debitCard.6a5bf992.png";